import tick from 'assets/images/tick.svg';
import cross from 'assets/images/cross.svg';

export const matrixCustomerData = (details) => [
    {
        id:1,
        icon:tick,
        amt:details?.trips || 0,
        name:"Completed Trip"
    },
    {
        id:2,
        icon:cross,
        amt:details?.cancelledTrips || 0,
        name:"Canceled Trip"
    }
]

